import * as React from "react";
import Typography from "@mui/material/Typography";

export default function UserGreeting({ currentTimeOfDay, userName }) {
	return (
		<>
			{userName ? (
				<Typography sx={{ fontWeight: 600 }} variant="h5">
					Good {currentTimeOfDay}, {userName}
				</Typography>
			) : (
				<Typography variant="h5">Good {currentTimeOfDay}</Typography>
			)}
		</>
	);
}
